import type {PageRouteConfig} from '@router';

import CouponAdd from 'modules/Services/PromotionCenter/Coupon/Add/CouponAdd';
import {routes} from 'routes/routes';

export function createPromotionCenterCouponAddRoute(): PageRouteConfig {
  return {
    element: <CouponAdd />,
    layout: {
      title: 'انتخاب کوپن',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: routes.PROMOTION_CENTER_COUPON_LIST,
      linkWithConfirmation: true,
      modalTitle: 'خروج از فرآیند ساخت کوپن؟',
      modalText: 'با خروج از فرآیند اطلاعاتی که ثبت کردید ذخیره نخواهد شد.'
    }
  };
}
